module.exports = __webpack_public_path__ + "media/images/vod_icons/stretchlab-5a1f8900b0133cbc3bd3185db82a78a8.svg";